<template>
    <div class="markdown-container">
        <overlay-shadow />
        <HomeMenu />
        <article>
            <router-view />
        </article>
    </div>
</template>

<script>
    import OverlayShadow from "overlays/Shadow";
    import HomeMenu from "components/application-specific/note/Menu";

    export default {
        name: "Logged",
        components: {
            OverlayShadow,
            HomeMenu
        }
    }
</script>

<style scoped>
    .markdown-container {
        position: relative;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: #fff;
    }
    article {
        position: absolute;
        top: 0px;
        left: 300px;
        right: 0px;
        height: 100%;
        transition: all 0.5s ease-in-out 0s;
    }

    @media screen and (max-width: 1100px) {
        article {
            left: 0;
        }
    }
</style>